namespace TabAurous.Sales {
    export namespace ProductSalesItemsService {
        export const baseUrl = 'Sales/ProductSalesItems';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/ProductSalesItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ProductSalesItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
